import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../../components/FormAssembly/FormAssembly";
import store from "../../../store";
import {Helmet} from "react-helmet";

const serviceFailureForm = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Manage" ? row.sections.map((section) => {
                        return section.title === "File a Claim" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Service Failure Form" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Service Failure Form</h1>
      <div className="iframe-box-wrapper">
        <FormAssembly formReferenceName="SERVICE_FAILURE_FORM"/>
      </div>
    </div>
  );
};

export default serviceFailureForm;



// WEBPACK FOOTER //
// ./src/pages/manage/FileAClaim/ServiceFailureForm.js